module.exports = __webpack_public_path__ + "block-3-2x-64ffe63897f8db5d837ea1484c5916e4.webp";